
import { addMonths, subMonths } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CalendarNavigationProps {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  checkInDate?: Date;
  checkOutDate?: Date;
  onClearDates?: () => void;
  isMobile: boolean;
}

const CalendarNavigation = ({ 
  currentDate, 
  setCurrentDate, 
  checkInDate, 
  checkOutDate, 
  onClearDates, 
  isMobile 
}: CalendarNavigationProps) => {
  const goToPreviousMonth = () => setCurrentDate(subMonths(currentDate, 1));
  const goToNextMonth = () => setCurrentDate(addMonths(currentDate, 1));

  return (
    <div className="flex items-center space-x-2">
      {!isMobile && (checkInDate || checkOutDate) && onClearDates && (
        <Button variant="outline" size="sm" onClick={onClearDates} className="text-sm">
          Limpiar fechas
        </Button>
      )}
      
      <Button variant="outline" size="sm" onClick={goToPreviousMonth} className="p-2">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="sm" onClick={goToNextMonth} className="p-2">
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default CalendarNavigation;
